import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ProductivityInsertService {

	private apiUrl = globalConst.baseAPI;
	constructor(private http: Http) { }

	getRegion(token) {
		

		
		
		
		
		
		

		return this.http
		.get(this.apiUrl + "/region/v1/getregion", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	insertProductivity(token, prod: any) {
		

		
		
		
		
		
		
		

		return this.http
		.post(this.apiUrl + "productivity/v1/insertaverage", JSON.stringify(prod), JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}


// WEBPACK FOOTER //
// ./src/app/productivity/service/productivity-insert/productivity-insert.service.ts